// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ueYB","title":"Header_title__1-1wd","left":"Header_left__29z0F","clinicName":"Header_clinicName__19vV_"};